module.exports = __webpack_public_path__ + "img/pic_intro.1d36b0bf.png";